import { isFulfillmentPlanStatusActionable } from './split-ship-modal-context-provider';

export const disableForItemCountOneOrLess = (selectedFulfillmentPlans) => {
  const items = selectedFulfillmentPlans.filter((fp) => isFulfillmentPlanStatusActionable(fp.orderGridStatus)).flatMap((fp) => fp.items);
  const itemCount = items?.length ?? 0;

  if (itemCount > 1) {
    return false;
  }
  if (itemCount === 1) {
    return items[0].quantity <= 1 && selectedFulfillmentPlans.length <= 1;
  }

  return true;
};
